export const STORAGE_KEY_TOKEN = 'auth-token'
export const STORAGE_KEY_TOKEN_V2 = 'auth-token-v2'
